import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import Rest from '../../webapi/Rest'
import * as layouts from 'arm-core-layouts';
import DocumentiActions from '../documenti/DocumentiActions';
import { Utils, DateFormatter, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';
import DataSourceActions from './DataSourceActions';
import DataSourcePreviewTab from './DataSourcePreviewTab.jsx';

class DataSourceCreate extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[DataSourceCreate.jsx] ";
        this.salvaDataSource = this.salvaDataSource.bind(this);
        this.elimDataSource = this.elimDataSource.bind(this);
        this.modificaDataSource = this.modificaDataSource.bind(this);
        this.salvaDS = this.salvaDS.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            validation: new Map(),
            showConfirmSalvaDS: false
        };
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        this.props.getDocumenti();
        this.props.setDefaultData();
        this.props.resetDSTab();
    }

    changeDSSelectedTab(idTab) {
        this.props.changeDSSelectedTab(idTab);
    }

    validateForm() {
        let validation = new Map();
        let required = ['alias', 'apiRest'];
        for (let i = 0; i < required.length; i++) {
            if (required[i] !== 'nome') {
                if (this.props.dataSource[required[i]] === undefined || this.props.dataSource[required[i]] === '' || this.props.dataSource[required[i]] === null) {
                    validation.set(required[i], i18n('ARM_CORE_PRINT.SHARED.VALORE_OBBLIGATORIO', 'Campo obbligatorio'));
                }
            }
            // else {
            //     let listParam = this.props.dataSource.listParam;
            //     if (!(listParam === undefined)) {
            //         for (let i = 0; i < listParam.length; i++) {
            //             if (listParam[i].nome === undefined || listParam[i].nome === null || listParam[i].nome === "") {
            //                 validation.set("nome" + i, i18n('ARM_CORE_PRINT.SHARED.VALORE_OBBLIGATORIO', 'Campo obbligatorio'));
            //             }
            //         }
            //     }
            // }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    handleChange(id, value) {

        let validation = this.state.validation;
        if (validation.has(id)) {
            validation.delete(id);
            this.setState({ validation: validation });
        }

        this.props.handleChangeDs(id, value);
    }

    handleChangePar(id, value, index) {
        let validation = this.state.validation;
        if (id === 'nome') {
            if (validation.has('nome' + index)) {
                validation.delete('nome' + index);
                this.setState({ validation: validation });
            }
        } else {
            if (validation.has(id)) {
                validation.delete(id);
                this.setState({ validation: validation });
            }
        }

        this.props.handleChangeParam(id, value, index)
    }


    salvaDataSource() {
        if (this.validateForm()) {
            this.setState({ showConfirmSalvaDS: true });
        }
    }

    salvaDS() {
        this.props.salvaDS().then(
            resolve => {
                // this.props.changeStatDett(true);
                this.setState({ showConfirmSalvaDS: false });
                this.props.history.goBack();
            }
        )
    }

    elimDataSource() {
        this.props.eliminaDataSource().then(
            resolve => {
                this.props.history.goBack();
            }
        )
    }

    modificaDataSource() {
        this.props.toggleModifica(true);
    }

    componentWillUnmount() {
        this.props.toggleModifica(false);
        this.props.changeStatDett(false);
        this.props.resetDS();
    }

    render() {

        const { dataSource, handleChangeDs, handleChangeParam, addParametro, deleteParametro, statusDett, modificaDSstat } = this.props;
        const baseUrl = Rest.restBaseurl;

        return (

            <div className="mt-3">
                <agui.aCard>
                    <agui.aCardHeader>
                        {/* <p>{i18n('ARM_CORE_PRINT.DS.NUOVO_DS', 'Nuova Data Source')}</p> */}
                        <p>{statusDett ? (modificaDSstat ? i18n('ARM_CORE_PRINT.MODIFICA_DS', `Modifica Data Source con id ${dataSource.id}`) : i18n('ARM_CORE_PRINT.DETTAGLIO_DS', `Dettaglio di data source con id ${dataSource.id}`)) : i18n('ARM_CORE_PRINT.NUOVO_DS', 'Nuova Data Source')}</p>

                    </agui.aCardHeader>
                    <br />
                    {/* <layouts.AutoSize offsetHeight={layouts.AutoSize.convertRemToPixels(4)}> */}

                    <agui.aCardBody className='dataSource'>
                        <div>
                            <ul className="nav nav-tabs ml-3 main-tabs" id="myTab" role="tablist">
                                <li className="active" >
                                    <a className={this.props.dataSourceTabSel === "dataSource-tab" ? "nav-link active" : "nav-link"} id="dataSource-tab" data-toggle="tab" href="#dataSourceTab" role="tab" aria-controls="dataSourceTab" aria-selected="true" onClick={() => this.changeDSSelectedTab('dataSource-tab')} >{i18n('ARM_CORE_PRINT.DATASOURCE', 'Data Source')}</a>
                                </li>
                                {statusDett && !modificaDSstat &&
                                    <li className="nav-item">
                                        <a className={this.props.dataSourceTabSel === "preview-tab" ? "nav-link active" : "nav-link"} id="preview-tab" data-toggle="tab" href="#previewTab" role="tab" aria-controls="previewTab" aria-selected="true" onClick={() => this.changeDSSelectedTab('preview-tab')}>{i18n('ARM_CORE_PRINT.SHARED.PREVIEW', 'Preview')}</a>
                                    </li>
                                }
                            </ul>

                            <div className="tab-document-content" id="TabDocumentContent">
                                <div className={this.props.dataSourceTabSel === 'dataSource-tab' ? 'tab-pane active' : 'tab-pane d-none'} id="dataSource-tab" role="tabpanel" aria-labelledby="dataSource-tab">

                                    {/* </div> */}


                                    <layouts.Form.Container >
                                        <layouts.HBox>
                                            <layouts.Form.Group  >
                                                <layouts.Form.SubGroup full>
                                                    {/* <layouts.Form.Item fixed>
                                            <agui.CoolSelect
                                                colwidth={4}
                                                id="idAiPrintDocument"
                                                onChange={(value) => handleChangeDs('idAiPrintDocument', value)}
                                                value={dataSource?.idAiPrintDocument}
                                                label={i18n('ARM_CORE_PRINT.DS.ID_DOCUMENT', 'Document')}
                                                required={true}
                                                hasError={this.state.validation.get("idAiPrintDocument")}
                                                items={this.props.listaDoc}
                                                valueKey="id"
                                                labelKey="alias"
                                                disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                            />
                                        </layouts.Form.Item> */}
                                                    <layouts.Form.Item minCharWidth={10} maxCharWidth={100} >
                                                        <agui.CoolTextInput
                                                            colwidth={4}
                                                            id="alias"
                                                            value={dataSource?.alias}
                                                            placeholder={i18n('ARM_CORE_PRINT.SHARED.ALIAS', 'Alias')}
                                                            required={true}
                                                            hasError={this.state.validation.get("alias")}
                                                            label={i18n('ARM_CORE_PRINT.SHARED.ALIAS', 'Alias')}
                                                            // onChange={(value) => handleChangeDs('alias', value)}
                                                            onChange={(value) => this.handleChange('alias', value)}
                                                            disabled={statusDett ? true : false}
                                                        />
                                                    </layouts.Form.Item>
                                                    <layouts.Form.Item minCharWidth={10} maxCharWidth={100}>
                                                        <agui.CoolSelect
                                                            colwidth={4}
                                                            id="formato"
                                                            onChange={(value) => handleChangeDs('formato', value)}
                                                            value={dataSource?.categoria}
                                                            label={i18n('ARM_CORE_PRINT.SHARED.FORMATO', 'Formato')}
                                                            // disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                                            disabled={statusDett ? true : false}
                                                            hasError={this.state.validation.get("formato")}
                                                            items={[{
                                                                value: 'JSON',
                                                                label: 'JSON'
                                                            }]}
                                                            valueKey="value"
                                                            labelKey="label"
                                                        />
                                                    </layouts.Form.Item>

                                                    <layouts.Form.Item minCharWidth={10} maxCharWidth={100}>
                                                        <agui.CoolTextInput
                                                            colwidth={4}
                                                            id="apiRest"
                                                            value={dataSource?.apiRest}
                                                            placeholder={i18n('ARM_CORE_PRINT.SHARED.ALIAS', 'Alias')}
                                                            required={true}
                                                            disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                                            hasError={this.state.validation.get("apiRest")}
                                                            label={i18n('ARM_CORE_PRINT.SHARED.API_REST', 'API Rest')}
                                                            // onChange={(value) => handleChangeDs('apiRest', value)}
                                                            onChange={(value) => this.handleChange('apiRest', value)}
                                                        />
                                                    </layouts.Form.Item>
                                                </layouts.Form.SubGroup>
                                            </layouts.Form.Group>
                                        </layouts.HBox>
                                        <layouts.HBox>
                                            <layouts.Form.Group >
                                                <layouts.Form.Item minCharWidth={10} maxCharWidth={55}>
                                                    <agui.CoolTextArea
                                                        rows={3}
                                                        id="sourceSample"
                                                        value={dataSource?.sourceSample}
                                                        required={false}
                                                        hasError={this.state.validation.get("sourceSample")}
                                                        label={i18n('ARM_CORE_PRINT.DS.SOURCE_SAMPLE', 'Source Sample')}
                                                        onChange={(value) => handleChangeDs('sourceSample', value)}
                                                        disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                                    />
                                                    <span colwidth={8}></span>
                                                </layouts.Form.Item>

                                            </layouts.Form.Group>
                                        </layouts.HBox>

                                        <>
                                            <div className='parametri'>
                                                <agui.LineBar>
                                                    <span style={{ fontSize: '1rem' }}>{i18n('ARM_CORE_PRINT.LISTA.PARAMETRI','Lista dei parametri')}</span>
                                                </agui.LineBar>
                                            </div>

                                            <div style={{ width: '100%', paddingRight: '0.5rem' }}>
                                                {
                                                    dataSource.listParam.length === 0 ?
                                                        <h4 className='mt-3'>{i18n('ARM_CORE_PRINT.DATASOURCE.PARAMETRI','Questa data source non ha parametri')}</h4>
                                                        :
                                                        dataSource.listParam && dataSource.listParam.map((param, index) => {
                                                            return <layouts.HBox>
                                                                <layouts.Form.Group >
                                                                    <layouts.Form.Item minCharWidth={10} maxCharWidth={100}>
                                                                        <agui.CoolTextInput
                                                                            disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                                                            colwidth={6}
                                                                            id="nome"
                                                                            value={param?.nome}
                                                                            required={false}
                                                                            // hasError={this.state.validation.get("nome" + index)}
                                                                            label={i18n('ARM_CORE_PRINT.DS.SOURCE_SAMPLE', 'Nome')}
                                                                            // onChange={(value) => handleChangeParam('nome', value, index)}
                                                                            onChange={(value) => this.handleChangePar('nome', value, index)}
                                                                        />
                                                                    </layouts.Form.Item>

                                                                    <layouts.Form.Item minCharWidth={10} maxCharWidth={100}>
                                                                        <agui.CoolTextInput
                                                                            disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                                                            colwidth={6}
                                                                            id="descrizione"
                                                                            value={param?.descrizione}
                                                                            required={false}
                                                                            // hasError={this.state.validation.get("descrizione")}
                                                                            label={i18n('ARM_CORE_PRINT.DS.SOURCE_SAMPLE', 'Descrizione')}
                                                                            onChange={(value) => handleChangeParam('descrizione', value, index)}
                                                                        />
                                                                    </layouts.Form.Item>

                                                                    {/* <layouts.Form.Item className='deleteParam' minCharWidth={1}> */}
                                                                    {/* <layouts.Form.Item minCharWidth={5} maxCharWidth={10}> */}
                                                                    <agui.aButton
                                                                        className='del-btn mt-4'
                                                                        small={true}
                                                                        icon='fas fa-solid fa-minus'
                                                                        onClick={() => deleteParametro(index)}
                                                                        disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                                                    />
                                                                    {/* </layouts.Form.Item> */}
                                                                    {/* </layouts.Form.Item> */}
                                                                </layouts.Form.Group>
                                                            </layouts.HBox>

                                                        })
                                                }
                                            </div>
                                            <>
                                                <agui.aButton
                                                    disabled={statusDett ? (modificaDSstat ? false : true) : false}
                                                    className='add-btn'
                                                    small={true}
                                                    onClick={() => addParametro()}
                                                >
                                                   {i18n('ARM_CORE_PRINTAGGIUGNI.PARAMETRO',' Aggiungi parametro')}
                                                </agui.aButton>
                                            </>
                                        </>
                                    </layouts.Form.Container>
                                </div>

                                {statusDett && !modificaDSstat &&
                                    <div className={this.props.dataSourceTabSel === 'preview-tab' ? 'tab-pane active mr-3' : 'tab-pane d-none'} id="preview-tab" role="tabpanel" aria-labelledby="preview-tab">
                                        <DataSourcePreviewTab />
                                    </div>
                                }

                            </div>
                        </div>

                        <agui.AskConfirm
                            show={this.state.showConfirmSalvaDS}
                            options={{
                                title: i18n('ARM_CORE_PRINT.SALVA.DATA.SOURCE','Salva Data Source'),
                                message: i18n('ARM_CORE_PRINT.CONFERMI.SOURCE','Confermi il salvataggio della data source?'),
                                warning: true,
                                yes: i18n('ARM_CORE_PRINT.SHARED.SI','Si'),
                                no: i18n('ARM_CORE_PRINT.SHARED.ANNULLA','Annulla'),
                            }}
                            onConfirm={() => {
                                this.salvaDS();
                            }}
                            onCancel={() => this.setState({ showConfirmSalvaDS: false })}
                        />
                    </agui.aCardBody>
                    {/* </layouts.AutoSize> */}
                    <agui.aCardFooter>
                        <agui.LineBar>
                            <agui.LineBarGroup>
                                {
                                    !statusDett ?
                                        <agui.aButton bs='primary' onClick={() => this.salvaDataSource()}
                                        // askConfirm={i18n('ARM_CORE_PRINT.DS.SALVA_DS_CONFIRM', 'Sei siccuro di voler procedere con il salvataggio?')}
                                        >
                                            {i18n('ARM_CORE_PRINT.MANAGE.SALVA', 'Salva')}
                                        </agui.aButton>
                                        :
                                        modificaDSstat ?
                                            <agui.aButton bs='primary' onClick={() => this.salvaDataSource()}
                                            // askConfirm={i18n('ARM_CORE_PRINT.DS.SALVA_DS_CONFIRM', 'Sei siccuro di voler procedere con il salvataggio?')}
                                            >
                                                {i18n('ARM_CORE_PRINT.MANAGE.SALVA', 'Salva')}
                                            </agui.aButton>
                                            : null
                                }

                                {
                                    statusDett && !modificaDSstat ?
                                        this.props.dataSourceTabSel === "preview-tab" ?
                                            <agui.aButton bs='primary'
                                                className='mt-3'
                                                onClick={() => this.props.stampaDsPreview()}>
                                                {i18n('ARM_CORE_PRINT.SHARED.PREVIEW', 'STAMPA')}
                                            </agui.aButton>
                                            :
                                            <>
                                                <agui.aButton bs='primary' className='mr-3' onClick={() => this.modificaDataSource()}
                                                    icon="fas-fa-edit"
                                                >
                                                    {i18n('ARM_CORE_PRINT.SHARED.MODIFICA', 'Modifica')}
                                                </agui.aButton>
                                                <agui.aButton
                                                    icon='fas fa-trash-alt'
                                                    onClick={this.elimDataSource}
                                                    askConfirm={i18n('ARM_CORE_PRINT.DS.ELIMINA_DS_CONFIRM', 'Sei siccuro di voler procedere con eliminazione?')}>
                                                    {i18n('ARM_CORE_PRINT.SHARED.ELIMINA', 'Elimina')}
                                                </agui.aButton>
                                            </>
                                        :
                                        null
                                }
                            </agui.LineBarGroup>
                            <agui.LineBarGroup right={true}>
                                <agui.aButton bs='secondary'
                                    // onClick={() => this.props.history.goBack()}
                                    onClick={() => this.props.history.location.state.lastPath === 'dataSource' ? this.props.history.push(`/dataSource/list`, { from: 'dataSource/create' }) : this.props.history.push({pathname: `/nuovoDoc`,state: { from: 'dataSource/create' }})}
                                >
                                    {
                                        statusDett && !modificaDSstat ? i18n('ARM_CORE_PRINT.SHARED.INDIETRO', 'Indietro') : i18n('ARM_CORE_PRINT.SHARED.ANNULLA', 'Annulla')
                                    }
                                </agui.aButton>
                            </agui.LineBarGroup>
                        </agui.LineBar>
                    </agui.aCardFooter>
                </agui.aCard>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleChangeDs(id, value) {
            return dispatch(DocumentiActions.handleChangeDs(id, value));
        },
        salvaDS() {
            return dispatch(DocumentiActions.salvaDS());
        },
        removeFile(fileIdx, name) {
            return dispatch(DocumentiActions.removeFile(fileIdx, name));
        },
        changeSelectedTab(idTab) {
            return dispatch(DocumentiActions.changeSelectedTab(idTab));
        },
        getDataSource() {
            return dispatch(DocumentiActions.getDataSource());
        },
        getDocumenti() {
            return dispatch(DocumentiActions.getDocumenti());
        },
        handleChangeParam(id, value, index) {
            return dispatch(DocumentiActions.handleChangeParam(id, value, index));
        },
        addParametro() {
            return dispatch(DocumentiActions.addParametro());
        },
        deleteParametro(index) {
            return dispatch(DocumentiActions.deleteParametro(index));
        },
        eliminaDataSource() {
            return dispatch(DocumentiActions.eliminaDataSource());
        },
        toggleModifica(mod) {
            return dispatch(DocumentiActions.toggleModifica(mod));
        },
        changeStatDett(statusDett) {
            return dispatch(DataSourceActions.changeStatDett(statusDett));
        },
        resetDS() {
            return dispatch(DocumentiActions.resetDS());
        },
        setDefaultData() {
            return dispatch(DocumentiActions.setDefaultData());
        },
        changeDSSelectedTab(idTab) {
            return dispatch(DocumentiActions.changeDSSelectedTab(idTab));
        },
        stampaDsPreview() {
            return dispatch(DocumentiActions.stampaDsPreview());
        },
        resetDSTab() {
            return dispatch(DocumentiActions.resetDSTab());
        }
    }
};

function mapStateToProps(state) {
    return {
        listaDoc: state.documentiReducer.listaDoc,
        dataSource: state.documentiReducer.dataSource,
        tabSelected: state.documentiReducer.tabSelected,
        listaDataSource: state.documentiReducer.listaDataSource,
        modificaDSstat: state.documentiReducer.modificaDSstat,
        statusDett: state.DataSourceReducer.statusDett,
        dataSourceTabSel: state.documentiReducer.dataSourceTabSel
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSourceCreate);
